import { useI18n } from './_i18n'

// JS mirror of app/services/locale_path.rb — the localized-URL scheme. English is
// the bare path (no prefix); the other 11 languages get a short URL segment. Keep
// these tables in sync with the Ruby side.

// catalog code -> URL segment. English -> null (bare). The `locale` page prop is
// always one of these 12 catalog codes (see ApplicationController#current_locale).
export const LOCALE_TO_SEGMENT = {
  en: null,
  es: 'es',
  de: 'de',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  nl: 'nl',
  da: 'da',
  nb: 'no',
  'pt-BR': 'pt',
  'zh-Hant': 'zh',
}

// hreflang tag (also the switcher key) for a catalog locale: the URL segment, or
// 'en' for English.
export function langTag(locale) {
  return LOCALE_TO_SEGMENT[locale] || 'en'
}

// Autonyms for the language switcher, keyed by hreflang tag (matches the keys of
// the server-shared `alternate_urls` prop).
export const LANGUAGE_NAMES = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  nl: 'Nederlands',
  da: 'Dansk',
  no: 'Norsk',
  pt: 'Português',
  zh: '中文',
}

// Prefix a bare (English) path for a locale. English (or unknown) -> unchanged.
// The home path "/" becomes "/es" (not "/es/") to match the localized root route.
export function localePath(path, locale) {
  const seg = LOCALE_TO_SEGMENT[locale]
  if (!seg) return path
  return path === '/' ? `/${seg}` : `/${seg}${path}`
}

// Hook: returns a path-prefixer bound to the current page's locale, so every
// internal link stays within the active language.
export function useLocalePath() {
  const { locale } = useI18n()
  return (path) => localePath(path, locale)
}

// Strip the origin from an absolute alternate URL to a same-host RELATIVE path.
// The shared alternate_urls are absolute (SiteUrl.base) for correct hreflang, but
// a language-switcher link must stay on the current host — an absolute link jumps
// to the production domain on localhost. See _LanguageSwitcher.
export function relativeAlternate(absoluteUrl, siteUrl) {
  return String(absoluteUrl).replace(siteUrl, '') || '/'
}
